import * as React from "react";
import { useParams } from "react-router-dom";
import { Box, CPText } from "../../../shared/components/base";
import {
  Card,
  CardBody,
  CardHeader,
  StackLayout,
} from "@progress/kendo-react-layout";
import logo from "../../../assets/evans-bi-logo2.png";
import { useRedeemInviteMutation } from "data/auth/auth";
import { storeCookie } from "shared/helpers";
import { accessTokenName } from "shared/config";
import dayjs from "dayjs";

const InvitePage: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const { mutate: redeemInvite } = useRedeemInviteMutation();
  const [failed, setFailed] = React.useState(false);
  const attempted = React.useRef(false);

  React.useEffect(() => {
    if (!code || attempted.current) return;
    attempted.current = true;

    redeemInvite(code, {
      onSuccess: (data) => {
        if (data?.token) {
          const expires =
            data?.expires ?? dayjs().add(8, "hour").toDate().toUTCString();
          storeCookie(accessTokenName, data.token, expires);
        }
        window.location.href = "/";
      },
      onError: () => {
        setFailed(true);
      },
    });
  }, [code, redeemInvite]);

  return (
    <Card className="login-form-card">
      <CardHeader>
        <Box
          alignItems="center"
          justifyContent="center"
          className="logo-container"
        >
          <img src={logo} alt="BI Hub Logo" className="login-logo" width="300" />
        </Box>
      </CardHeader>
      <CardBody>
        <StackLayout
          orientation="vertical"
          gap={16}
          align={{ horizontal: "center" }}
        >
          {failed ? (
            <>
              <CPText textStyle="h6" align="center">
                Invite Link Invalid
              </CPText>
              <CPText textStyle="subtitle" align="center">
                This invite link is invalid or has expired. Please contact
                your agency manager for a new invite.
              </CPText>
            </>
          ) : (
            <>
              <CPText textStyle="h6" align="center">
                Signing You In&hellip;
              </CPText>
              <CPText textStyle="subtitle" align="center">
                Please wait while we set up your account.
              </CPText>
            </>
          )}
        </StackLayout>
      </CardBody>
    </Card>
  );
};

export default InvitePage;
